import React from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import NullableValue from "../../../../../../../../Utils/renderField/nullableValue";
import { RenderKilogramo } from "../../../../../../../../Utils/renderField/renderReadField";

const verIcon = require("assets/img/icons/ver.png");
const reabrirIcon = require("assets/img/icons/refresh.png");

export const TurnosFinalizadosTable = ({
    turnosFinalizados = [],
    ReabrirTurno,
}) => {
    return (
        <div className="new-table-wrapper turnos-produccion__table-wrapper sticky-header sticky-first-column">
            <table className="table-striped">
                <thead>
                    <tr>
                        <th rowSpan={2}>Supervisor</th>
                        <th rowSpan={2} className="text-nowrap ">
                            Op. Báscula
                        </th>
                        <th rowSpan={2} className="text-nowrap">
                            Op. Montacargas
                        </th>
                        <th rowSpan={2} className="text-nowrap">
                            Fecha Inicial
                        </th>
                        <th
                            rowSpan={2}
                            className="text-nowrap cell-border-right"
                        >
                            Fecha Final
                        </th>
                        <th
                            colSpan={2}
                            className="text-nowrap cell-border-right"
                        >
                            Materia prima
                        </th>
                        <th
                            colSpan={3}
                            className="text-nowrap cell-border-right"
                        >
                            Total kg secos
                        </th>
                        <th rowSpan={2} className="text-nowrap cell-border-right">
                            Producción del turno
                        </th>
                        <th rowSpan={2} className="text-nowrap">
                            Kg sobrantes
                        </th>
                        <th
                            rowSpan={2}
                            className="text-nowrap cell-border-right"
                        >
                            Enviado a bodega
                        </th>
                        <th rowSpan={2} className="text-nowrap">
                            Acciones
                        </th>
                    </tr>
                    <tr>
                        <th className="text-nowrap">
                            Kg húmedos
                        </th>
                        <th className="text-nowrap cell-border-right">
                            Kg secos
                        </th>

                        <th className="text-nowrap">Turno actual</th>
                        <th className="text-nowrap">Turno anterior</th>
                        <th className="text-nowrap cell-border-right">
                            Reclasificación
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {turnosFinalizados.length === 0 && (
                        <tr>
                            <td colSpan={14} className="text-center">
                                No hay turnos finalizados para mostrar
                            </td>
                        </tr>
                    )}
                    {turnosFinalizados.map((item) => {
                        return (
                            <tr key={item.id}>
                                <td
                                    className="text-center"
                                    style={{ minWidth: "150px" }}
                                >
                                    <NullableValue value={item.supervisores}>
                                        {item.supervisores}
                                    </NullableValue>
                                </td>
                                <td className="text-center">
                                    {item.operador_bascula}
                                </td>
                                <td className="text-center">
                                    {item.operador_montacargas}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.fecha_inicial &&
                                        moment(item.fecha_inicial).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.fecha_final &&
                                        moment(item.fecha_final).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                </td>

                                <td className="text-center text-nowrap">
                                    <NullableValue
                                        value={item.kg_humedos_tancadas}
                                    >
                                        <RenderKilogramo
                                            value={item.kg_humedos_tancadas}
                                            decimalScale={2}
                                        />
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <RenderKilogramo
                                        value={item.kg_secos_tancadas || 0}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={
                                            item.kg_producidos_turno_actual || 0
                                        }
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={
                                            item.kg_producidos_turno_anterior ||
                                            0
                                        }
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <RenderKilogramo
                                        value={
                                            item.kg_pacas_reclasificacion || 0
                                        }
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    <RenderKilogramo
                                        value={item.kg_produccion_turno || 0}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_sobrantes_turno || 0}
                                        decimalScale={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap cell-border-right">
                                    {item.sobrante_enviado_bodega ? "Sí" : "No"}
                                </td>
                                <td className="text-center text-nowrap">
                                    <Link
                                        to={`/produccion-v2/detalle-turno-finalizado/${item.id}`}
                                    >
                                        <img
                                            src={verIcon}
                                            alt="Ver detalle"
                                            title="Ver detalle"
                                            className="action_img"
                                        />
                                    </Link>
                                    {ReabrirTurno && item.puede_reabrirse && (
                                        <img
                                            src={reabrirIcon}
                                            alt="Reabrir turno"
                                            title="Reabrir turno"
                                            className="action_img ml-2"
                                            onClick={() => ReabrirTurno(item)}
                                        />
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};
